import React, { useEffect, useCallback } from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { colors } from '@mui/material';
import { Page, Header } from 'components';

import HuaweiRemoteAnalysisForm from './components/HuaweiRemoteAnalysisForm.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const HuaweiRemoteAnalysis = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	return (
		<Page className={classes.root} title="CM">
			<Header module="CM" view="Huawei Remote Analysis" />
			<div className={clsx(classes.container)}>
				<HuaweiRemoteAnalysisForm />
			</div>
		</Page>
	);
};

export default HuaweiRemoteAnalysis;
